export const TAB_KEY = "tab";
export const ENTER_KEY = "enter";
export const F_KEY = "f";
export const ARROW_UP_KEY = "up";
export const ARROW_DOWN_KEY = "down";
export const ARROW_LEFT_KEY = "left";
export const ARROW_RIGHT_KEY = "right";
export const ESCAPE_KEY = "esc";
